export default function TagElement({ attributes, children, element }) {
  return (
    <span
      {...attributes}
      contentEditable={false}
      title={`#${element.tag}`}
      style={{
        display: "inline-block",
        padding: "2px 8px",
        margin: "0 2px",
        background: "#fff4e6",
        borderRadius: 6,
        border: "1px solid #ffe0b2",
        fontWeight: 600,
        color: "#a55b00"
      }}
    >
      #{element.tag}
      {children}
    </span>
  );
}
